// Complete field schema for a UK Certificate of Sponsorship,
// grouped exactly the way the Home Office document is grouped.

export const YN_OPTIONS = [
  { value: "Y", label: "Y" },
  { value: "N", label: "N" },
];

export const SEX_OPTIONS = [
  { value: "Female", label: "Female" },
  { value: "Male", label: "Male" },
];

export const STATUS_OPTIONS = [
  { value: "READY TO GO", label: "READY TO GO" },
  { value: "ASSIGNED", label: "ASSIGNED" },
  { value: "USED", label: "USED" },
  { value: "WITHDRAWN", label: "WITHDRAWN" },
  { value: "EXPIRED", label: "EXPIRED" },
  { value: "CANCELLED", label: "CANCELLED" },
];

export const FOR_OPTIONS = [
  { value: "Year", label: "Year" },
  { value: "Month", label: "Month" },
  { value: "Week", label: "Week" },
  { value: "Hour", label: "Hour" },
];

// Sections: id, title, fields[{name,label,type,options?,textarea?,colSpan?}]
export const SECTIONS = [
  {
    id: "tier",
    title: "Tier and Category",
    fields: [
      {
        name: "tier_and_category",
        label: "Tier and category",
        type: "select",
        options: [
          { value: "Skilled Worker (Switching immigration category - ISC liable)", label: "Skilled Worker (Switching immigration category - ISC liable)" },
          { value: "Skilled Worker (New hires - defined)", label: "Skilled Worker (New hires - defined)" },
        ],
        colSpan: 2,
      },
    ],
  },
  {
    id: "cos_status",
    title: "Certificate of Sponsorship status",
    fields: [
      { name: "sponsor_licence_number", label: "Sponsor licence number" },
      { name: "sponsor_name", label: "Sponsor name" },
      { name: "certificate_number", label: "Certificate number" },
      {
        name: "current_certificate_status",
        label: "Current certificate status",
        type: "select",
        options: STATUS_OPTIONS,
      },
      { name: "current_certificate_status_date", label: "Current certificate status date" },
      { name: "date_assigned", label: "Date assigned" },
      { name: "expiry_date_use_by", label: "Expiry date (use by)" },
      {
        name: "sponsorship_withdrawn",
        label: "Sponsorship withdrawn",
        type: "select",
        options: YN_OPTIONS,
      },
      { name: "sponsor_note", label: "Sponsor note", textarea: true, colSpan: 2 },
      { name: "migrant_application_status", label: "Migrant application status", colSpan: 2 },
    ],
  },
  {
    id: "personal",
    title: "Personal information",
    fields: [
      { name: "family_name", label: "Family name" },
      { name: "given_names", label: "Given name(s)" },
      { name: "other_names", label: "Other names" },
      { name: "nationality", label: "Nationality" },
      { name: "place_of_birth", label: "Place of birth" },
      { name: "country_of_birth", label: "Country of birth" },
      { name: "date_of_birth", label: "Date of birth (DD/MM/YYYY)" },
      { name: "sex", label: "Sex", type: "select", options: SEX_OPTIONS },
      { name: "country_of_residence", label: "Country of residence" },
    ],
  },
  {
    id: "passport",
    title: "Passport or travel document",
    fields: [
      { name: "passport_number", label: "Passport number" },
      { name: "passport_issue_date", label: "Issue date" },
      { name: "passport_expiry_date", label: "Expiry date" },
      { name: "passport_place_of_issue", label: "Place of issue of passport" },
    ],
  },
  {
    id: "home",
    title: "Current home address",
    fields: [
      { name: "home_address", label: "Address", colSpan: 2 },
      { name: "home_city", label: "City or town" },
      { name: "home_area_district", label: "Country, area district or province" },
      { name: "home_postcode", label: "Postcode" },
      { name: "home_country", label: "Country" },
    ],
  },
  {
    id: "identification",
    title: "Identification numbers",
    fields: [
      { name: "uk_id_card_number", label: "UK ID card number" },
      { name: "uk_ni_number", label: "UK National insurance number" },
      { name: "national_id_card_number", label: "National ID card number" },
      { name: "employee_number", label: "Employee number" },
    ],
  },
  {
    id: "work_dates",
    title: "Work dates",
    fields: [
      { name: "start_date", label: "Start date" },
      { name: "end_date", label: "End date" },
      {
        name: "need_leave_reenter",
        label: "Does the migrant need to leave and re-enter the UK during the period of approval?",
        type: "select",
        options: YN_OPTIONS,
      },
      { name: "total_weekly_hours", label: "Total weekly hours of work" },
    ],
  },
  {
    id: "work_address",
    title: "Main work address in the United Kingdom (mandatory for assignment)",
    fields: [
      { name: "work_address", label: "Address", colSpan: 2 },
      { name: "work_city", label: "City or town" },
      { name: "work_area_district", label: "Country, area district or province" },
      { name: "work_postcode", label: "Postcode" },
    ],
  },
  {
    id: "other_work",
    title: "Other regular work addresses in the United Kingdom",
    fields: [
      {
        name: "other_work_addresses",
        label: "Other regular work addresses",
        textarea: true,
        colSpan: 2,
      },
    ],
  },
  {
    id: "employment",
    title: "Migrant's employment",
    fields: [
      { name: "job_title", label: "Job title" },
      { name: "job_type", label: "Job type (SOC code — description)" },
      {
        name: "summary_of_job_description",
        label: "Summary of job description",
        textarea: true,
        colSpan: 2,
        rows: 6,
      },
      {
        name: "new_entrant",
        label: "New Entrant?",
        type: "select",
        options: YN_OPTIONS,
      },
      {
        name: "gross_salary",
        label:
          "Gross salary in pounds sterling (Skilled Worker only: excluding any allowances or guaranteed bonuses)",
      },
      { name: "salary_for", label: "For", type: "select", options: FOR_OPTIONS },
      {
        name: "confirm_appropriate_skill_level",
        label:
          "Tick to confirm that the post is at the appropriate skill level as set out in the sponsor guidance",
        type: "select",
        options: YN_OPTIONS,
      },
      {
        name: "confirm_maintenance",
        label: "Tick for maintenance for migrant (and dependants, if applicable)",
        type: "select",
        options: YN_OPTIONS,
      },
      {
        name: "atas_required",
        label:
          "Does the worker require an Academic Technology Approval Scheme (ATAS) certificate for this role?",
        type: "select",
        options: YN_OPTIONS,
      },
    ],
  },
  {
    id: "paye",
    title: "Migrant's employment - PAYE",
    fields: [
      {
        name: "paye_reference_supplied",
        label: "PAYE reference supplied?",
        type: "select",
        options: YN_OPTIONS,
      },
      { name: "paye_reference_number", label: "PAYE reference number" },
    ],
  },
  {
    id: "phd",
    title: "Migrant's employment - PhD",
    fields: [
      {
        name: "phd_required",
        label: "Is PhD Level qualification required for post?",
        type: "select",
        options: YN_OPTIONS,
      },
    ],
  },
];

export const EMPTY_COS = {
  tier_and_category: "Skilled Worker (Switching immigration category - ISC liable)",
  sponsor_licence_number: "",
  sponsor_name: "",
  certificate_number: "",
  current_certificate_status: "ASSIGNED",
  current_certificate_status_date: "",
  date_assigned: "",
  expiry_date_use_by: "",
  sponsorship_withdrawn: "N",
  sponsor_note: "",
  migrant_application_status: "",
  family_name: "",
  given_names: "",
  other_names: "",
  nationality: "",
  place_of_birth: "",
  country_of_birth: "",
  date_of_birth: "",
  sex: "Female",
  country_of_residence: "",
  passport_number: "",
  passport_issue_date: "",
  passport_expiry_date: "",
  passport_place_of_issue: "",
  home_address: "",
  home_city: "",
  home_area_district: "",
  home_postcode: "",
  home_country: "",
  uk_id_card_number: "",
  uk_ni_number: "",
  national_id_card_number: "",
  employee_number: "",
  start_date: "",
  end_date: "",
  need_leave_reenter: "N",
  total_weekly_hours: "",
  work_address: "",
  work_city: "",
  work_area_district: "",
  work_postcode: "",
  other_work_addresses: "",
  job_title: "",
  job_type: "",
  summary_of_job_description: "",
  new_entrant: "N",
  gross_salary: "",
  salary_for: "Year",
  confirm_appropriate_skill_level: "Y",
  confirm_maintenance: "Y",
  atas_required: "N",
  paye_reference_supplied: "Y",
  paye_reference_number: "",
  phd_required: "N",
};
